export const BASE_URL = "http://ssrf.climatecentral.org.s3-website-us-east-1.amazonaws.com";

export const DB_HOST = process.env.SLRDB_HOST || 'slrdb-replica.cc2dvqvaangc.us-east-1.rds.amazonaws.com';
export const DB_NAME = process.env.SLRDB_NAME || 'slrdb';
export const DB_PORT = process.env.SLRDB_PORT || '5432';
export const DB_USER = process.env.SLRDB_USER || 'ssrf';
export const DB_PASS = process.env.SLRDB_PASS || '';
// export const DB_HOST = process.env.SLRDB_HOST || 'slrdb.climatecentral.org';
// export const DB_NAME = process.env.SLRDB_NAME || 'slrdb_v3';
// export const DB_USER = process.env.SLRDB_USER || 'slrdb';
// export const DB_PASS = process.env.SLRDB_PASS || '';
export const DB_DIR = process.env.DB_DIR || '/data/slr/ssrf';

export const GOOGLE_ANALYTICS = {
  googleAnalyticsId: 'UA-29844012-2',
  ga4MeasurementId: 'G-4TFTR0K7E0',
};

export const DL_SERVICE_URL = "https://ssws.climatecentral.org";
// export const DL_SERVICE_URL = "http://ssws-dev.us-east-1.elasticbeanstalk.com";
// export const DL_SERVICE_URL = "http://slr01:8895";

export const OWL_EVENT_URL = "https://owl.climatecentral.org/event";

export const WEB_URL_BASE = "http://riskfinder.climatecentral.org";

export const FACT_SHEET_URL = "https://d1vp6fby7xv7sc.cloudfront.net";

export const ZILLOW_MAP_URL = "https://rzh.climatecentral.org";

export const ABBREVIATIONS = {
  "Legislative": "Leg.",
  "City": "City",
  "District": "Dist.",
  "Grant": "Gnt.",
  "Philadelphia": "Phila.",
  "Commission": "Comsn.",
  "Board": "Brd.",
  "Boundary": "Bdry.",
  "Valley": "Val.",
  "Meeting": "Mtg.",
  "Manhattan": "Mhtn.",
  "Commissioner": "Comr.",
  "Transportation": "Transp.",
  "Government": "Govt.",
  "Academy": "Acad.",
  "Regional": "Reg.",
  "Supervisorial": "Supervis.",
  "Brooklyn": "Bklyn.",
  "Planning": "Plng.",
  "Representative": "Rep.",
  "Los Angeles": "L.A.",
  "Queens": "Qns.",
  "Township": "Twp.",
  "Governments": "Govts",
  "School": "Sch.",
  "Central": "Cntrl.",
  "United States": "U.S.",
  "Unincorporated": "Uninc",
  "Staten Island S.": "I.",
  "Bronx": "Bx.",
  "Ward": "Wd.",
  "Neighborhood": "Nbhd.",
  "New Jersey": "NJ",
  "Municipality": "Muni.",
  "Community": "Cmty.",
  "County": "Co.",
  "New York": "NY",
  "At-Large": "At-Lrg.",
  "Council": "Coun.",
  "Village": "Vlg.",
  "Borough": "Bor."
};

export const STATE_NAME_ABBREVS = {
  "alabama": "AL",
  "alaska": "AK",
  "california": "CA",
  "connecticut": "CT",
  "delaware": "DE",
  "district of columbia": "DC",
  "florida": "FL",
  "georgia": "GA",
  "hawaii": "HI",
  "louisiana": "LA",
  "maine": "ME",
  "maryland": "MD",
  "massachusetts": "MA",
  "mississippi": "MS",
  "new hampshire": "NH",
  "new jersey": "NJ",
  "new york": "NY",
  "north carolina": "NC",
  "oregon": "OR",
  "pennsylvania": "PA",
  "rhode island": "RI",
  "south carolina": "SC",
  "texas": "TX",
  "virginia": "VA",
  "washington": "WA",
};
